

import {
  Component,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { Impresa } from "src/app/models/impresa.model";
import { Listino } from "src/app/models/listino.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { ListiniService } from "src/app/services/listini.service";


@Component({
  templateUrl: "./dialog-crea-listino.component.html",
  styleUrls: ["../listino.component.css"],
})
export class CreaListinoComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  protected aziende: Impresa[]      = [];
  protected aziendeConListino: Impresa[]      = [];
  public creaListinoMandatorioForm: FormGroup;

  public creaListinoLiguriaForm: FormGroup;
  public creaListinoPiemonteForm: FormGroup;
  public creaListinoSardegnaForm: FormGroup;

  protected pagineCreaListino: MenuItem[];
  protected activeIndex: number = 0;
  
  protected isCreatingListino:Boolean = false;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private impreseService: ImpreseService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _formBuilder: FormBuilder,
    private listiniService:ListiniService,
  ) {
    this.aziendeConListino = this.config.data.aziendeConListino;
    this.creaListinoMandatorioForm = this._formBuilder.group({
      azienda:                    [null, [Validators.required]],
      ita1:                       new FormControl({value: 181.2, disabled: true}, Validators.required),
      ita2:                       new FormControl({value: 264.9, disabled: true}, Validators.required),
      ita3:                       new FormControl({value: 235.5, disabled: true}, Validators.required),
      ita4:                       new FormControl({value: 69.6, disabled: true}, Validators.required),
      ita5:                       new FormControl({value: 182, disabled: true}, Validators.required),
      preventivoBaseItalia:       new FormControl({value: 682.4, disabled: true}, Validators.required),
    });

    
    this.creaListinoLiguriaForm = this._formBuilder.group({
      liguria1:                   [null],
      liguria2:                   [null],
      liguria3:                   [null],
      liguria4:                   [null],
      liguria5:                   [null],
      preventivoBaseLiguria:      [null]
    });
    this.creaListinoPiemonteForm = this._formBuilder.group({
      piemonte1:                  [null],
      piemonte2:                  [null],
      piemonte3:                  [null],
      piemonte4:                  [null],
      piemonte5:                  [null],
      preventivoBasePiemonte:     [null]
    });
    this.creaListinoSardegnaForm = this._formBuilder.group({
      sardegna1:                  [null],
      sardegna2:                  [null],
      sardegna3:                  [null],
      sardegna4:                  [null],
      sardegna5:                  [null],
      preventivoBaseSardegna:     [null]
    });
    this.loadAziende();
  }

  ngOnInit(): void {
    
    this.creaListinoMandatorioForm.get('ita2')?.valueChanges.subscribe(() => this.updatePreventivoBaseItalia());
    this.creaListinoMandatorioForm.get('ita3')?.valueChanges.subscribe(() => this.updatePreventivoBaseItalia());
    this.creaListinoMandatorioForm.get('ita5')?.valueChanges.subscribe(() => this.updatePreventivoBaseItalia());

    this.creaListinoLiguriaForm.get('liguria2')?.valueChanges.subscribe(() => this.updatePreventivoBaseLiguria());
    this.creaListinoLiguriaForm.get('liguria3')?.valueChanges.subscribe(() => this.updatePreventivoBaseLiguria());
    this.creaListinoLiguriaForm.get('liguria5')?.valueChanges.subscribe(() => this.updatePreventivoBaseLiguria());


    this.creaListinoPiemonteForm.get('piemonte2')?.valueChanges.subscribe(() => this.updatePreventivoBasePiemonte());
    this.creaListinoPiemonteForm.get('piemonte3')?.valueChanges.subscribe(() => this.updatePreventivoBasePiemonte());
    this.creaListinoPiemonteForm.get('piemonte5')?.valueChanges.subscribe(() => this.updatePreventivoBasePiemonte());

    this.creaListinoSardegnaForm.get('sardegna2')?.valueChanges.subscribe(() => this.updatePreventivoBaseSardegna());
    this.creaListinoSardegnaForm.get('sardegna3')?.valueChanges.subscribe(() => this.updatePreventivoBaseSardegna());
    this.creaListinoSardegnaForm.get('sardegna5')?.valueChanges.subscribe(() => this.updatePreventivoBaseSardegna());
  
    this.inizializzaSteps();
  }

  inizializzaSteps() {
    this.pagineCreaListino = [
      {
        label: "Italia",
      },
      {
        label: "Liguria",
      },
      {
        label: "Piemonte",
      },
      {
        label: "Sardegna",
      }
    ];
    this.activeIndex = 0;
  }
  checkNextStep(): boolean {
    let disableNextStepButton = false;
    if (this.activeIndex === this.pagineCreaListino.length - 1) {
      disableNextStepButton = true;
    }else if (this.activeIndex === 0 && !this.creaListinoMandatorioForm.valid) {
      disableNextStepButton = true;
    }else if (this.activeIndex === 1 && !this.creaListinoLiguriaForm.valid ) {
      disableNextStepButton = true;
    }else if (this.activeIndex === 2 && !this.creaListinoPiemonteForm.valid ) {
      disableNextStepButton = true;
    }else if (this.activeIndex === 3 && !this.creaListinoSardegnaForm.valid ) {
      disableNextStepButton = true;
    }
    return disableNextStepButton;
  }
  changePage() {
    this.activeIndex = this.activeIndex + 1;
  
  }
  updatePreventivoBaseItalia() {
    const ita2 = this.creaListinoMandatorioForm.get('ita2')?.value || 0;
    const ita3 = this.creaListinoMandatorioForm.get('ita3')?.value || 0;
    const ita5 = this.creaListinoMandatorioForm.get('ita5')?.value || 0;
    this.creaListinoMandatorioForm.get('preventivoBaseItalia')?.setValue(ita2 + ita3 + ita5, { emitEvent: false });
  }
  updatePreventivoBaseLiguria() {
    this.logger.info("--> updatePreventivoBaseLiguria INIZIO "+ this.creaListinoLiguriaForm.get('preventivoBaseLiguria'));
    const liguria2 = this.creaListinoLiguriaForm.get('liguria2')?.value || 0;
    const liguria3 = this.creaListinoLiguriaForm.get('liguria3')?.value || 0;
    const liguria5 = this.creaListinoLiguriaForm.get('liguria5')?.value || 0;
    this.creaListinoLiguriaForm.get('preventivoBaseLiguria')?.setValue(liguria2 + liguria3 + liguria5, { emitEvent: false });
    this.logger.info("--> updatePreventivoBaseLiguria FINE "+ this.creaListinoLiguriaForm.get('preventivoBaseLiguria'));

  }
  updatePreventivoBasePiemonte() {
    const piemonte2 = this.creaListinoPiemonteForm.get('piemonte2')?.value || 0;
    const piemonte3 = this.creaListinoPiemonteForm.get('piemonte3')?.value || 0;
    const piemonte5 = this.creaListinoPiemonteForm.get('piemonte5')?.value || 0;
    this.creaListinoPiemonteForm.get('preventivoBasePiemonte')?.setValue(piemonte2 + piemonte3 + piemonte5, { emitEvent: false });
  }
  updatePreventivoBaseSardegna() {
    const sardegna2 = this.creaListinoSardegnaForm.get('sardegna2')?.value || 0;
    const sardegna3 = this.creaListinoSardegnaForm.get('sardegna3')?.value || 0;
    const sardegna5 = this.creaListinoSardegnaForm.get('sardegna5')?.value || 0;
    this.creaListinoSardegnaForm.get('preventivoBaseSardegna')?.setValue(sardegna2 + sardegna3 + sardegna5, { emitEvent: false });
  }

  loadAziende(){
    this.logger.info("LOADING AZIENDE");
    this.impreseService.get().subscribe( {
        next: (res) => {
          this.aziende = res.filter(azienda => 
            !this.aziendeConListino.some(aziendaConListino => aziendaConListino.id === azienda.id));
            this.logger.info(this.aziende);
        },
        error: (e) => {
          this.logger.info(e);
          this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di caricamento aziende'});
      },
        complete: () => {
        }
    });
}
  
  isFormValorizzato(formGroup: FormGroup): boolean {
    return Object.values(formGroup.value).some(value => value !== null && value !== undefined && value !== '');
  }

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.isCreatingListino = true;
      let listino:Listino = new Listino();
      listino.azienda               = this.creaListinoMandatorioForm.value.azienda;
     /*  listino.italia1               = 181.2;
      listino.italia2               = 264.9;
      listino.italia3               = 235.5;
      listino.italia4               = 69.6;
      listino.italia5               = 182;
      listino.preventivoBaseItalia  = 682.4; */
      //verifico liguria
      if(this.isFormValorizzato(this.creaListinoLiguriaForm)){
        listino.liguria1               = this.creaListinoLiguriaForm.value.liguria1;
        listino.liguria2               = this.creaListinoLiguriaForm.value.liguria2;
        listino.liguria3               = this.creaListinoLiguriaForm.value.liguria3;
        listino.liguria4               = this.creaListinoLiguriaForm.value.liguria4;
        listino.liguria5               = this.creaListinoLiguriaForm.value.liguria5;
        listino.preventivoBaseLiguria  = this.creaListinoLiguriaForm.value.preventivoBaseLiguria;
      }

      //verifico piemonte
      if(this.isFormValorizzato(this.creaListinoPiemonteForm)){
        listino.piemonte1               = this.creaListinoPiemonteForm.value.piemonte1;
        listino.piemonte2               = this.creaListinoPiemonteForm.value.piemonte2;
        listino.piemonte3               = this.creaListinoPiemonteForm.value.piemonte3;
        listino.piemonte4               = this.creaListinoPiemonteForm.value.piemonte4;
        listino.piemonte5               = this.creaListinoPiemonteForm.value.piemonte5;
        listino.preventivoBasePiemonte  = this.creaListinoPiemonteForm.value.preventivoBasePiemonte;
      }

       //verifico sardegna
       if(this.isFormValorizzato(this.creaListinoSardegnaForm)){
        listino.sardegna1               = this.creaListinoSardegnaForm.value.sardegna1;
        listino.sardegna2               = this.creaListinoSardegnaForm.value.sardegna2;
        listino.sardegna3               = this.creaListinoSardegnaForm.value.sardegna3;
        listino.sardegna4               = this.creaListinoSardegnaForm.value.sardegna4;
        listino.sardegna5               = this.creaListinoSardegnaForm.value.sardegna5;
        listino.preventivoBaseSardegna  = this.creaListinoSardegnaForm.value.preventivobaseSardegna;
       }

       this.listiniService.crea(listino).subscribe( {
        next: (resCreaProgetto) => {
          this.isCreatingListino = false;
          this.dialogRef.close({ success: true });
        },
        error: (e) => {
            this.isCreatingListino = false;
            this.logger.error(e);
            this.dialogRef.close({ success: false });
            this.messageService.add({
              severity: "error",
              summary: "ATTENZIONE",
              detail: "Errore in fase di creazione di un nuovo listino!", life:10000
            });
      },
        complete: () => {

          //this.isLoadingResults = false;
        }
    }); 
    }
  }
}
